import React from 'react';
import { TouchableOpacity } from 'react-native';
import { View } from 'react-native-animatable';
import styled from 'styled-components/native';

import { Tours, TourGuide, Immigration } from '@src/components/icons';

import { Body1 } from '@src/components/Typography';
import { padding, shortcutSize } from '@src/configuration/constants';

type Props = {
  children: React.ReactNode;
  icon: string;
  onPress?: () => void;
};

const Container = styled(TouchableOpacity)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0px 5px 24px 10px;
  width: ${shortcutSize + padding / 4}px;
  height: ${shortcutSize + padding}px;
  border-color: ${({ theme }) => theme.colors.backdrop};
  border-width: 0px;
  border-radius: 4px;
`;

const TextView = styled(View)`
  margin-top: 2px;
`;

const SVGContainer = styled(View)`
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom:8px;
  width: ${shortcutSize + 2}px;
  height: ${shortcutSize + 2}px;
  border-radius: 16;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.background};
  shadow-offset: {width: 0, height:0};
  shadow-opacity: 1;
  shadow-radius: 8;
  elevation: 1;
`;
const Shortcut: React.FC<Props> = ({ children, icon, onPress }) => {
  return (
    <Container onPress={onPress}>
      <SVGContainer>
        {icon === 'book' ? (
          <TourGuide width={38} height={45} />
        ) : icon === 'immigration' ? (
          <Immigration width={45} height={45} />
        ) : (
          <Tours width={38} height={45} />
        )}
      </SVGContainer>
      <TextView>
        <Body1>{children}</Body1>
      </TextView>
    </Container>
  );
};

export default React.memo(Shortcut);
